import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modal: {
    position: 'absolute',
    borderWidth: 0,
  },
  container: {
    flex: 1,
    backgroundColor: '#000',
    opacity: 0.6,
  },
  modalBox: {
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    position: 'absolute',
    justifyContent: 'flex-start',
  },
  modalContentLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
    paddingHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 10,
    backgroundColor: '#FFFFFF',
    marginTop: 85,
    marginRight: 150,
  },
  modalContentSmall: {
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    backgroundColor: '#FFFFFF',
    marginTop: 165,
  },
  closeIconContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-end',
  },
  statusContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  pressableStatusContainer: {
    flexDirection: 'row',
    width: '100%',
    marginBottom: 10,
  },
  outsideStatusContainer: {
    paddingVertical: 4,
    paddingLeft: 4,
    paddingRight: 21,
  },
  insideStatusContainer: {
    paddingHorizontal: 8,
    paddingVertical: 8,
  },
  statusText: {
    color: '#000000',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
});
